<template>
  <main>
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>
    <div class="tabs-header">
      <span
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{ active: activeTab === index }"
        @click="selectTab(index)"
      >
        {{ tab }}
      </span>
    </div>
    <div class="tab-content">
      <div v-if="activeTab === 0">
        <div class="card-stats-container">
          <SummaryCard
            :logo="require('@/assets/img/people.png')"
            title="Total Accounts"
            :number="this.totalAccounts"
          />

          <SummaryCard
            :logo="require('@/assets/img/not_activated.png')"
            title="Not Activated"
            :number="this.notActivated.count"
            :percentage="this.notActivated.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/activated.png')"
            title="Activated"
            :number="this.activated.count"
            :percentage="this.activated.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/enabled.png')"
            title="Login Access (Enabled)"
            :number="this.loginAccessEnabled.count"
            :percentage="
              this.loginAccessEnabled.percent + '% of Total Accounts'
            "
          />
        </div>

        <div class="card-stats-container">
          <SummaryCard
            :logo="require('@/assets/img/disabled.png')"
            title="Login Access (Disabled)"
            :number="this.loginAccessDisabled.count"
            :percentage="
              this.loginAccessDisabled.percent + '% of Total Accounts'
            "
          />

          <SummaryCard
            :logo="require('@/assets/img/enabled.png')"
            title="PND Status (Active)"
            :number="this.pndStatus.active.count"
            :percentage="this.pndStatus.active.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/disabled.png')"
            title="PND Status (Inactive)"
            :number="this.pndStatus.inactive.count"
            :percentage="
              this.pndStatus.inactive.percent + '% of Total Accounts'
            "
          />

          <SummaryCard
            :logo="require('@/assets/img/na.png')"
            title="PND Status (N/A)"
            :number="this.pndStatus.na.count"
            :percentage="this.pndStatus.na.percent + '% of Total Accounts'"
          />
        </div>
      </div>

      <div v-if="activeTab === 1">
        <div class="accountTypeOptions">
          <span
            v-for="tab in accountTypesOptions"
            :key="tab.key"
            :class="{ activeType: activeAccount === tab.key }"
            @click="handleAccountType(tab.key)"
          >
            {{ tab.label }}
          </span>
        </div>

        <div v-if="activeAccount === 'accountTier'">
          <div class="accountType-stats-container">
            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Individual Accounts"
              :number="this.accountTypes.individual.count"
              :percentage="
                this.accountTypes.individual.percent + '% of Total Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="No Tier"
              :number="this.individualTiers.noTier.count"
              :percentage="
                this.individualTiers.noTier.percent + '% of Individual Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Tier 1"
              :number="this.individualTiers.tier1.count"
              :percentage="
                this.individualTiers.tier1.percent + '% of Individual Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Tier 2"
              :number="this.individualTiers.tier2.count"
              :percentage="
                this.individualTiers.tier2.percent + '% of Individual Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Tier 3"
              :number="this.individualTiers.tier3.count"
              :percentage="
                this.individualTiers.tier3.percent + '% of Individual Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Business Accounts"
              :number="this.accountTypes.business.count"
              :percentage="
                this.accountTypes.business.percent + '% of Total Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Sole Proprietor"
              :number="this.businessCategories.soleProprietorship.count"
              :percentage="
                this.businessCategories.soleProprietorship.percent +
                '% of Business Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Private LLC"
              :number="this.businessCategories.privateLimited.count"
              :percentage="
                this.businessCategories.privateLimited.percent +
                '% of Business Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/not_activated.png')"
              title="No Business Category"
              :number="this.businessCategories.noCategory.count"
              :percentage="
                this.businessCategories.noCategory.percent +
                '% of Business Accounts'
              "
            />

            <SummaryCard :logo="require('@/assets/img/not_activated.png')"
            title="No Account Type" :number="this.noAccountType.count"
            :percentage=" this.noAccountType.percent + '% of Total Accounts'""
            />
            <!-- <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Customer Category 1"
              :number="this.customerCategories[1].count"
              :percentage="
                this.customerCategories[1].percent + '% of Total Accounts'
              "
            />

            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Customer Category 2"
              :number="this.customerCategories[2].count"
              :percentage="
                this.customerCategories[2].percent + '% of Total Accounts'
              "
            />
            <SummaryCard
              :logo="require('@/assets/img/people.png')"
              title="Customer Category 3"
              :number="this.customerCategories[3].count"
              :percentage="
                this.customerCategories[3].percent + '% of Total Accounts'
              "
            /> -->
          </div>
        </div>

        <div v-if="activeAccount === 'accountCategories'">
          <div style="display: flex; align-items: center; gap: 20px">
            <div class="accountType-stats-container">
              <SummaryCard
                v-for="(category, index) in paginatedCategories"
                :key="index"
                :logo="require('@/assets/img/people.png')"
                :title="
                  category.merchantName || `Customer Category ${index + 1}`
                "
                :number="category.count"
                :percentage="category.percent + '% of Total Accounts'"
              />
            </div>
          </div>
          <div
            class="slider-controls"
            style="text-align: center; margin-bottom: 1rem"
          >
            <button
              @click="prevSlide"
              class="btn btn-blue"
              :disabled="currentSlide === 0"
            >
              ⬅ Prev
            </button>
            <button
              @click="nextSlide"
              class="btn btn-blue"
              :disabled="currentSlide === totalSlides - 1"
            >
              Next ➡
            </button>
          </div>
        </div>
      </div>

      <!-- KYC & Compliance -->
      <div v-if="activeTab === 2">
        <div class="accountType-stats-container">
          <SummaryCard
            :logo="require('@/assets/img/verified.png')"
            title="Verified KYC"
            :number="this.verified.count"
            :percentage="this.verified.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/partially.png')"
            title="Partially Verified KYC"
            :number="this.partiallyVerified.count"
            :percentage="this.partiallyVerified.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/pending.png')"
            title="Pending KYC"
            :number="this.pending.count"
            :percentage="this.pending.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/rejected.png')"
            title="Rejected KYC"
            :number="this.rejected.count"
            :percentage="this.rejected.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/unverified.png')"
            title="Unverified KYC"
            :number="this.unverified.count"
            :percentage="this.unverified.percent + '% of Total Accounts'"
          />

          <SummaryCard
            :logo="require('@/assets/img/rejected.png')"
            title="N/A KYC"
            :number="this.kycUnkwown.count"
            :percentage="this.kycUnkwown.percent + '% of Total Accounts'"
          />
        </div>
      </div>
    </div>

    <div class="search-container">
      <div class="search-items">
        <div class="col-auto" style="">
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="accountType">Account Type</option>
            <option value="firstName">Customer Category</option>
            <option value="walletId">Wallet ID</option>
            <option value="phoneNumber">Phone Number</option>
            <option value="pndStatus">PND Status</option>
            <option value="createdAt">Date Created</option>
            <option value="activatedAt">Date Activated</option>
            <option value="loginAccess">Login Access</option>
            <option value="verifiedStatus">KYC Status</option>
            <option value="customerCategory">Customer Category</option>
            <option value="salesOfficer">Sales Officer</option>
          </select>
        </div>

        <div
          v-if="
            selectedValue &&
            selectedValue !== 'accountType' &&
            selectedValue !== 'createdAt' &&
            selectedValue !== 'activatedAt' &&
            selectedValue !== 'pndStatus' &&
            selectedValue !== 'loginAccess' &&
            selectedValue !== 'verifiedStatus'
          "
        >
          <div class="input-group m-0">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValue"
              :placeholder="`Enter ${formattedSearchValue}`"
              type="text"
            />
          </div>
        </div>

        <div class="col-auto" v-if="selectedValue === 'accountType'">
          <select
            class="form-control"
            v-model="searchValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select an account type</option>
            <option value="individual-account">Individual Account</option>
            <option value="business-account">Business Account</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'pndStatus'">
          <select
            class="form-control"
            v-model="searchValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a PND Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'loginAccess'">
          <select
            class="form-control"
            v-model="searchValue"
            :placeholder="'Select a login access'"
          >
            <option value="">Select a Login Access</option>
            <option value="disabled">Disabled</option>
            <option value="enabled">Enabled</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'verifiedStatus'">
          <select
            class="form-control"
            v-model="searchValue"
            :placeholder="'Select a login access'"
          >
            <option value="">Select a KYC Status</option>
            <option value="verified">Verified</option>
            <option value="partially_verified">Partially Verified</option>
            <option value="pending">Pending</option>
            <option value="rejected">Rejected</option>
            <option value="unverified">Unverified</option>
          </select>
        </div>

        <div
          class="row"
          style="display: flex; gap: 8px"
          v-if="selectedValue === 'createdAt'"
        >
          <div class="col-md-4 p-0" style="width: 100%; max-width: 50%">
            <fg-input
              type="date"
              label="Start Date"
              placeholder="Start Date"
              v-model="createdAtStartDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>
          <div class="col-md-4 p-0" style="width: 100%; max-width: 50%">
            <fg-input
              type="date"
              label="End Date"
              placeholder="End Date"
              v-model="createdAtEndDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>
        </div>

        <div
          class="row"
          style="display: flex; gap: 8px"
          v-if="selectedValue === 'activatedAt'"
        >
          <div class="col-md-4 p-0" style="width: 100%; max-width: 50%">
            <fg-input
              type="date"
              label="Start Date"
              placeholder="Start Date"
              v-model="activationStartDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>

          <div class="col-md-4 p-0" style="width: 100%; max-width: 50%">
            <fg-input
              type="date"
              label="End Date"
              placeholder="End Date"
              v-model="activationEndDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>
        </div>
      </div>

      <div class="action_btns">
        <button
          type="submit"
          class="btn btn-blue"
          :disabled="dateError || isSearchDisabled"
          @click="refresh('filter')"
        >
          FILTER
        </button>

        <button class="btn btn-blue" @click="refresh('reload')">REFRESH</button>

        <button class="btn btn-blue" @click="refresh('download')">
          EXPORT CSV
        </button>
      </div>
    </div>

    <div class="col-12 p-0">
      <card class="card-plain p-0">
        <div class="table-responsive p-0">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Customer Name</th>
                <th scope="col" class="text-center">Customer Category</th>
                <th scope="col" class="text-center">Phone Number</th>
                <th scope="col" class="text-center">Wallet ID</th>
                <th scope="col" class="text-center">Account Type</th>
                <th scope="col" class="text-center">Tier</th>
                <th scope="col" class="text-center">PND Status</th>
                <th scope="col" class="text-center">Date Created</th>
                <th scope="col" class="text-center">Date Activated</th>
                <th scope="col" class="text-center">Activated By</th>
                <th scope="col" class="text-center">KYC Status</th>
                <th scope="col" class="text-center">SalesOfficer</th>
                <th scope="col" class="text-center">Login Access</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loadingAgents === true">
                <td colspan="100%" class="text-center">
                  <div>
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading Agents...</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-else-if="agentList.length === 0 && loadingAgents === false">
                <td colspan="100%" class="text-center">
                  <div class="">
                    <div class="alert-icon">
                      <i class="fa fa-info-circle"></i>
                    </div>
                    <span>No Agents Found</span>
                  </div>
                </td>
              </tr>

              <template v-else>
                <tr
                  v-for="(agent, index) in agentList"
                  :key="agent._id"
                  style="background-color: #fff"
                >
                  <th class="text-center">
                    {{ limit * (page - 1) + (index + 1) }}
                  </th>
                  <td class="text-center">
                    {{ agent.firstName }} {{ agent.middleName }}
                    {{ agent.lastName }}
                  </td>

                  <td class="text-center">
                    {{ getMerchantName(agent.merchantId) }}
                  </td>

                  <td class="text-center">{{ agent.phoneNumber }}</td>

                  <td class="text-center">{{ agent.walletId }}</td>
                  <td class="text-center" style="text-transform: capitalize">
                    {{ removeAccountSuffix(agent.accountType) }}
                  </td>

                  <td class="text-center text-uppercase">
                    {{ formatTier(agent.accountType, agent.tier) }}
                  </td>

                  <td class="text-center text-uppercase">
                    <span
                      class="status"
                      :class="{
                        'status-enabled': agent.PNDStatus === 'active',
                        'status-disabled': agent.PNDStatus === 'inactive',
                        'status-other': agent.PNDStatus === 'N/A',
                      }"
                      >{{ agent.PNDStatus }}</span
                    >
                  </td>

                  <td class="text-center">
                    {{ moment(agent.createdAt).format("DD.MM.YYYY hh:mm") }}
                  </td>

                  <td class="text-center" v-if="agent.activatedAt">
                    {{ moment(agent.activatedAt).format("DD.MM.YYYY hh:mm") }}
                  </td>
                  <td class="text-center" v-else>Inactive</td>
                  <td class="text-center">{{ agent.activitedBy }}</td>
                  <td class="text-center">
                    <span
                      class="statuses"
                      :class="{
                        'all-status-verified':
                          agent.verifiedStatus === 'verified',
                        'all-status-partially-verified':
                          agent.verifiedStatus === 'partially_verified',
                        'all-status-rejected':
                          agent.verifiedStatus === 'rejected',
                        'all-status-pending':
                          agent.verifiedStatus === 'pending',
                        'all-status-unverified':
                          agent.verifiedStatus === 'unverified',
                      }"
                      >{{ getFormattedStatus(agent.verifiedStatus) }}</span
                    >
                  </td>
                  <td class="text-center">{{ agent.SalesOfficer }}</td>
                  <td class="text-center text-uppercase">
                    <span
                      class="status"
                      :class="
                        agent.disabled ? 'status-disabled' : 'status-enabled'
                      "
                      >{{ agent.disabled ? "Disabled" : "enabled" }}</span
                    >
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="pagination">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";
import { formatTier } from "../utils/utils";
import SummaryCard from "../components/Cards/SummaryCard.vue";

export default {
  components: {
    SummaryCard,
  },

  data() {
    return {
      tabs: [
        "Accounts Overview",
        "Account Type (Tiers & Categories)",
        "KYC and Compliance",
      ],
      errorMsg: "Error",
      error: false,
      activeTab: 0,
      loading: false,
      loadingAgents: false,
      currentPage: 1,
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      accountTypes: {},
      businessCategories: {},
      customerCategories: [],
      individualTiers: {},
      noAccountType: {},
      activated: {},
      notActivated: {},
      loginAccessDisabled: {},
      loginAccessEnabled: {},
      pndStatus: {},
      kycUnkwown: {},
      partiallyVerified: {},
      pending: {},
      rejected: {},
      unverified: {},
      verified: {},
      page: 1,
      limit: 50,
      totalPages: 0,
      totalDocs: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
      agentList: [],
      filteredAgentList: [],
      download: false,
      download: false,
      searchValues: {
        walletId: "",
        phoneNumber: "",
        firstName: "",
        accountType: "",
        createdAt: "",
        activatedAt: "",
        pndStatus: "",
        loginAccess: "",
        verifiedStatus: "",
        customerCategory: "",
        salesOfficer: "",
      },
      selectedValue: "",
      inputError: false,
      createdAtStartDate: "",
      createdAtEndDate: "",
      activationStartDate: "",
      activationEndDate: "",
      dateError: false,
      previousValue: "",
      allMerchants: [],
      totalAccounts: 0,
      slider: "left",
      currentSlide: 0,
      itemsPerSlide: 10,
      activeAccount: "accountTier",
      accountTypesOptions: [
        { label: "Tier", key: "accountTier" },
        { label: "Categories", key: "accountCategories" },
      ],
      tabDataLoaded: [false, false, false],
    };
  },

  computed: {
    formattedSearchValue() {
      return this.selectedValue
        ? this.selectedValue
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/\b\w/g, (char) => char.toUpperCase())
        : "";
    },

    searchValue: {
      get() {
        return this.selectedValue ? this.searchValues[this.selectedValue] : "";
      },
      set(value) {
        if (this.selectedValue) {
          this.searchValues[this.selectedValue] = value;
        }
      },
    },

    isSearchDisabled() {
      switch (this.selectedValue) {
        case "accountType":
          return !this.searchValue;

        case "firstName":
          return !this.searchValue || this.searchValue.trim().length === 0;

        case "walletId":
        case "phoneNumber":
          return !this.searchValue || !/^\d+$/.test(this.searchValue);

        case "pndStatus":
          return !this.searchValue;

        case "createdAt":
          return !this.createdAtStartDate || !this.createdAtEndDate;

        case "activatedAt":
          return !this.activationStartDate || !this.activationEndDate;
        case "loginAccess":
          return !this.searchValue;
        case "verifiedStatus":
          return !this.searchValue;
        case "customerCategory":
          return !this.searchValue;
        case "salesOfficer":
          return !this.searchValue;
        default:
          return true;
      }
    },

    totalSlides() {
      return Math.ceil(this.customerCategories.length / this.itemsPerSlide);
    },

    paginatedCategories() {
      const start = this.currentSlide * this.itemsPerSlide;
      return this.customerCategories.slice(start, start + this.itemsPerSlide);
    },
  },

  methods: {
    selectTab(index) {
      this.activeTab = index;
      this.loadTabData(index);
    },

    handleAccountType(type) {
      this.activeAccount = type;
    },

    nextSlide() {
      if (this.currentSlide < this.totalSlides - 1) {
        this.currentSlide++;
      }
      console.log("click next");
    },

    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--;
      }
    },

    formatTier,
    removeAccountSuffix(accountType) {
      return (accountType || "").replace("-account", "");
    },

    getFormattedStatus(status) {
      const statusMap = {
        verified: "Verified",
        partially_verified: "Partially Verified",
        rejected: "Rejected",
        pending: "Pending",
        unverified: "Unverified",
      };
      return statusMap[status] || status;
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/merchant/get-all-merchants`,
        );
        const { merchants } = res.data;
        this.allMerchants = merchants;
        console.log(this.allMerchants);
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getMerchantName(id) {
      const merchant = this.allMerchants.find(
        (merchant) => merchant._id === id,
      );
      return merchant ? merchant.merchantName : "";
    },

    async getAccountOverview() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/account-overview`,
        );
        const {
          activated,
          loginAccessDisabled,
          loginAccessEnabled,
          notActivated,
          pndStatus,
          totalAccounts,
        } = res.data.data;

        this.activated = activated;
        this.loginAccessDisabled = loginAccessDisabled;
        this.loginAccessEnabled = loginAccessEnabled;
        this.notActivated = notActivated;
        this.pndStatus = pndStatus;
        this.totalAccounts = totalAccounts;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async getAccountType() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/account-type-overview`,
        );

        const {
          accountTypes,
          businessCategories,
          customerCategories,
          individualTiers,
          noAccountType,
          totalAccounts,
        } = res.data.data;

        this.accountTypes = accountTypes;

        this.businessCategories = businessCategories;
        this.customerCategories = customerCategories;
        this.individualTiers = individualTiers;
        this.noAccountType = noAccountType;
        this.totalAccounts = totalAccounts;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async getKycCompliance() {
      this.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/analytics/kyc-status-overview`,
        );

        const {
          kycUnkwown,
          partiallyVerified,
          pending,
          rejected,
          unverified,
          verified,
        } = res.data.data.kyc;

        this.kycUnkwown = kycUnkwown;
        this.partiallyVerified = partiallyVerified;
        this.pending = pending;
        this.rejected = rejected;
        this.unverified = unverified;
        this.verified = verified;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async refresh(mode) {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loadingAgents = true;

        let payload = {
          page: this.page,
          firstName: this.firstName,
          download: this.download,
          pndStatus: this.PNDStatus,
          loginAccess: this.loginAccess,
          verifiedStatus: this.verifiedStatus,
          SalesOfficer: this.SalesOfficer,
          ...this.searchValues,
        };

        payload = {
          ...payload,
          createdAtStartDate: this.createdAtStartDate,
          createdAtEndDate: this.createdAtEndDate,
          activationStartDate: this.activationStartDate,
          activationEndDate: this.activationEndDate,
        };

        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "filter":
            this.page = 1;
            this.currentPage = 1;

            payload = {
              ...payload,
              page: this.page,
              ...this.searchValues,
            };
            break;
          case "reload":
            this.page = 1;
            payload = {
              page: this.page,
            };
            this.selectedValue = "";
            this.searchValues = "";
            this.currentPage = 1;
            this.activationStartDate = "";
            this.activationEndDate = "";
            this.createdAtStartDate = "";
            this.createdAtEndDate = "";
            break;
        }

        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/agent-list`,
          payload,
        );

        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.agentList);
          fileDownload(csvTran, "agents_list.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.agentList;
          this.merchants = docs.map((merchant) => ({
            ...merchant,
            isDropdownOpen: false,
          }));
          this.agentList = docs;
          this.filteredAgentList = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Download Agents List";
      }
      this.loadingAgents = false;
    },

    clearSearchFields() {
      this.searchValues = {
        terminalId: "",
        walletId: "",
        phoneNumber: "",
        firstName: "",
        accountType: "",
        reference: "",
        stan: "",
        createdAt: "",
        activatedAt: "",
        pndStatus: "",
        loginAccess: "",
        verifiedStatus: "",
        customerCategory: "",
        salesOfficer: "",
      };
    },

    async loadTabData(index) {
      if (this.tabDataLoaded[index]) return;

      switch (index) {
        case 0:
          await this.getAccountOverview();
          await this.getMerchants();
          break;
        case 1:
          await this.getAccountType();
          break;
        case 2:
          await this.getKycCompliance();
          break;
      }

      this.tabDataLoaded.splice(index, 1, true);
    },
  },

  watch: {
    selectedValue(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        const tempValue = newValue;
        this.refresh("reload");
        this.selectedValue = tempValue;
      }
      this.clearSearchFields();
      this.previousValue = newValue;
    },

    createdAtStartDate(newStart) {
      if (this.createdAtEndDate && newStart > this.createdAtEndDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },

    createdAtEndDate(newEnd) {
      if (this.createdAtStartDate && newEnd < this.createdAtStartDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },

    activationStartDate(newStart) {
      if (this.activationEndDate && newStart > this.activationEndDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },

    activationEndDate(newEnd) {
      if (this.activationStartDate && newEnd < this.activationStartDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },
  },

  async mounted() {
    this.loadTabData(0);
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/agent-list`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.agentList;
      this.agentList = docs;
      this.filteredAgentList = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Agents";
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.tabs-header {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 24px;
  border-bottom: 1px solid #9a9a9a;
  color: #9a9a9a;
  margin-bottom: 30px;
  cursor: pointer;
}

span.active {
  padding: 8px 20px;
  color: #1eb75b;
  border-bottom: 1px solid #1eb75b;
  font-weight: 600;
  cursor: pointer;
}

.card-stats-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.accountType-stats-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  width: 100%;
}

.status {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.status-enabled {
  background: #1eb75b;
  color: #fff;
}
.status-disabled {
  background: #e02b00;
  color: #fff;
}
.status-other {
  color: #b5af03;
  background: rgba(181, 175, 3, 0.1);
}

.statuses {
  text-transform: capitalize;
  font-size: 14px;
  border-radius: 4px;
  padding: 4px 12px;
  display: flex;
  justify-content: center;
}

.all-status-verified {
  color: #1eb75b;
  background: rgba(30, 183, 91, 0.1);
}
.all-status-partially-verified {
  color: #b5af03;
  background: rgba(181, 175, 3, 0.1);
}
.all-status-rejected {
  color: #e02b00;
  background: rgba(224, 43, 0, 0.1);
}
.all-status-pending {
  color: #f2b630;
  background: rgba(242, 182, 48, 0.1);
}
.all-status-unverified {
  color: #6880e4;
  background: rgba(104, 128, 228, 0.1);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 24px;
}

.action_btns {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-items {
  display: flex;
  align-items: center;
  gap: 30px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(10px);
}

.accountTypeOptions {
  display: flex;
  align-items: center;
  gap: 20px;
  width: fit-content;
  background: white;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
  color: #9291a5;
  margin-bottom: 24px;
}

span {
  cursor: pointer;
}

span.activeType {
  cursor: pointer;
  background: #65b3c7;
  color: white;
  padding: 6px 8px;
  border-radius: 4px;
  width: 100%;
  min-width: 80px;
  text-align: center;
}
</style>
